import Subscription from '../components/Subscription/Subscription';

export default Subscription;